const SIZE = {
  xs: "text-lg sm:text-xl",
  sm: "text-xl sm:text-2xl",
  md: "text-2xl sm:text-3xl",
  lg: "text-3xl sm:text-4xl",
  xl: "text-4xl sm:text-5xl",
  "2xl": "text-5xl sm:text-6xl",
};
const GAP = { none: "gap-0", tight: "gap-0", normal: "gap-0.5", relaxed: "gap-2", loose: "gap-4" };
const GAP_STYLE = { none: { marginTop: "-0.35em" }, tight: { marginTop: "-0.15em" } };
const TRACKING = { tighter: "tracking-tighter", tight: "tracking-tight", normal: "tracking-normal", wide: "tracking-wide", wider: "tracking-wider", widest: "tracking-widest" };
const ALIGN = { left: "items-start text-left", center: "items-center text-center", right: "items-end text-right" };

export const TITLE_FONTS = {
  serif: { label: "Cormorant Garamond (elegant serif)", family: "'Cormorant Garamond', serif" },
  playfair: { label: "Playfair Display (classic serif)", family: "'Playfair Display', serif" },
  lora: { label: "Lora (soft serif)", family: "'Lora', serif" },
  cinzel: { label: "Cinzel (Roman capitals)", family: "'Cinzel', serif" },
  sans: { label: "Manrope (modern sans)", family: "'Manrope', sans-serif" },
  script: { label: "Great Vibes (handwritten)", family: "'Great Vibes', cursive" },
};

const lineStyle = (content, prefix) => ({
  fontFamily: (TITLE_FONTS[content?.[`${prefix}_font`]] || TITLE_FONTS.serif).family,
  fontWeight: content?.[`${prefix}_weight`] === "bold" ? 700 : 400,
  fontStyle: content?.[`${prefix}_italic`] ? "italic" : "normal",
  ...(content?.[`${prefix}_color`] ? { color: content[`${prefix}_color`] } : {}),
});

const lineSize = (content, prefix, compact) => (compact ? "text-xl sm:text-2xl" : SIZE[content?.[`${prefix}_size`]] || SIZE.md);
const lineTracking = (content, prefix) => TRACKING[content?.[`${prefix}_tracking`]] || TRACKING.tight;

export const siteTitleInline = (content) =>
  [content?.site_title || "Sree Siddha Vignana Sadhana", (content?.site_title2 || "").trim()].filter(Boolean).join(" · ");

export const SiteTitle = ({ content, compact = false, testId = "site-title" }) => {
  const line2 = (content?.site_title2 || "").trim();
  const gap = content?.site_title_gap || "normal";
  return (
    <div className={`flex flex-col ${compact ? "gap-0.5 items-start text-left" : `${GAP[gap] || GAP.normal} ${ALIGN[content?.site_title_align] || ALIGN.center}`}`}>
      <span data-testid={testId} className={`leading-tight ${lineTracking(content, "site_title")} ${lineSize(content, "site_title", compact)}`} style={lineStyle(content, "site_title")}>
        {content?.site_title || "Sree Siddha Vignana Sadhana"}
      </span>
      {line2 && (
        <span data-testid={`${testId}-line2`} className={`leading-tight ${lineTracking(content, "site_title2")} ${lineSize(content, "site_title2", compact)}`} style={{ ...lineStyle(content, "site_title2"), ...(compact ? {} : GAP_STYLE[gap] || {}) }}>
          {line2}
        </span>
      )}
    </div>
  );
};
